<template>
    <v-expansion-panel class="div-4">

      <v-expansion-panel-title>
        <div class="div-5">
          <div class="div-6">
            <div class="text-5"> Handmatig invoer</div>
          </div>
        </div>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-row>
          <div class="form-fields w-100">
            <div class="cost-field">
              <label for="cost" class="field-label">Kosten</label>
              <div class="input-wrapper">
                <input
                    type="number"
                    id="cost"
                    class="field-input"
                    placeholder="Voer de kosten in"
                />
                <img
                    src="/assets/euro.svg"
                    class="field-icon"
                    alt=""
                />
              </div>
            </div>

            <div class="date-fields">
              <div class="date-field">
                <label for="startDate" class="field-label">Van</label>
                <div class="input-wrapper">
                  <input
                      type="date"
                      id="startDate"
                      class="field-input"
                      placeholder="begin"
                  />
                </div>
              </div>

              <div class="date-field">
                <label for="endDate" class="field-label">Tot</label>
                <div class="input-wrapper">
                  <input
                      type="date"
                      id="endDate"
                      class="field-input"
                      prefix="/assets/calendar.svg"
                      placeholder="eind"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="button-2 mb-3">
            <img loading="lazy"
                 src="/assets/plus.svg"
                 class="img-5"/>
            <div class="button-3">Meer toevoegen</div>
          </div>
        </v-row>
      </v-expansion-panel-text>
    </v-expansion-panel>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'ManualInputSection'
})
</script>

<style scoped>

.input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.cost-field, .date-field {
  border-radius: 8px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  background: var(--Neutral-background, #f7f8fc);
  padding: 4px 8px;
  min-height: 46px;
}
.field-label {
  color: var(--Neutral-8, #595c69);
  font-size: 12px;
  font-weight: 500;
}

.field-input {
  width: 100%;
  border: none;
  background: transparent;
  color: var(--Neutral-7, #787a87);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
}
.date-fields {
  display: flex;
  gap: 8px;
}

.date-field {
  flex: 1;
}

.div-4 {
  border-radius: 16px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  display: flex;
  margin-top: 24px;
  width: 100%;
  flex-direction: column;
  font-family: Montserrat, sans-serif;
  justify-content: start;
}

.div-5 {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-size: 16px;
  color: var(--Neutral-5, #191a1f);
  font-weight: 700;
  line-height: 2;
  justify-content: start;
}

.div-6 {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.text-5 {
  align-self: stretch;
  flex: 1;
  flex-basis: 0%;
  margin: auto 0;
}

.field {
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  background: var(--Neutral-background, #f7f8fc);
  background-color: var(--Neutral-background, #f7f8fc);
  display: flex;
  margin-top: 16px;
  min-height: 46px;
  width: 100%;
  gap: 8px;
  justify-content: start;
  flex-wrap: wrap;
  padding: 4px 8px;
}

.div-7 {
  align-self: stretch;
  display: flex;
  min-width: 240px;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  flex-basis: 0%;
  margin: auto 0;
}

.label {
  color: var(--Neutral-8, #595c69);
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.placeholder {
  color: var(--Neutral-7, #787a87);
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
}

.div-8 {
  display: flex;
  margin-top: 16px;
  width: 100%;
  align-items: start;
  gap: 8px;
  white-space: nowrap;
  justify-content: start;
  flex-wrap: wrap;
}

.field-2, .field-3 {
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  background: var(--Neutral-background, #f7f8fc);
  background-color: var(--Neutral-background, #f7f8fc);
  display: flex;
  min-width: 240px;
  min-height: 46px;
  gap: 8px;
  justify-content: start;
  flex: 1;
  flex-basis: 0%;
  padding: 4px 8px;
}

.div-9, .div-10 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  flex-basis: 0%;
  margin: auto 0;
}

.label-2, .label-3 {
  color: var(--Neutral-8, #595c69);
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.placeholder-2, .placeholder-3 {
  color: var(--Neutral-7, #787a87);
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
}

.button-2 {
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--secondary-secondary, #ff9f1c);
  align-self: start;
  display: flex;
  margin-top: 16px;
  width: 136px;
  min-height: 24px;
  gap: 4px;
  font-size: 12px;
  color: var(--secondary-secondary, #ff9f1c);
  font-weight: 500;
  line-height: 1;
  padding: 4px 8px;
}

.img-5 {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 16px;
  align-self: stretch;
  margin: auto 0;
}

.button-3 {
  align-self: stretch;
  margin: auto 0;
}

.img {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 20px;
  align-self: stretch;
  margin: auto 0;
}

@media (max-width: 991px) {
  .div-4,
  .div-5,
  .div-6,
  .text-5,
  .field,
  .div-7,
  .label,
  .placeholder,
  .div-8,
  .field-2,
  .field-3,
  .div-9,
  .div-10 {
    max-width: 100%;
    white-space: initial;
  }
}
</style>